/**
 * Client-side mirrors of server limits.
 *
 * The API exposes no settings endpoint, so this number is a *copy* of
 * `MAX_ATTACHMENT_SIZE_BYTES` in the deployment's `.env` (100 MB), not a
 * reading of it. It exists for one reason: to fail a 200 MB file instantly
 * instead of uploading it for a minute and then being refused (§5).
 *
 * The server stays the authority. If the two ever drift, the upload goes out,
 * comes back 413, and the UI surfaces that error — the check here is an
 * optimisation, never the enforcement.
 */
export const MAX_ATTACHMENT_BYTES = 100 * 1024 * 1024;

export const MAX_ATTACHMENT_MB = Math.round(MAX_ATTACHMENT_BYTES / (1024 * 1024));

/**
 * The workspace's Inbox project — a fixed system UUID created by
 * `workspace_bootstrap`. Quick capture drops a task here when the person has
 * not said which project it belongs to, because asking "which project?" at
 * capture time is the friction that stops people capturing at all.
 */
export const INBOX_PROJECT_ID = "00000000-0000-0000-0000-00000000beef";
